import React from 'react'
import { isEmpty, isObject, map } from 'lodash'

import { TreeSelectNodeTitle } from '../components/sections'
import { stringIncludes } from '../utils'

const renderTreeSelectHighlightsForSearch = (options = [], searchValue = '') =>
  map(options, item => {
    const title = isObject(item.title) ? item.title?.props?.title : item.title

    return {
      ...item,
      ...(stringIncludes(title, searchValue) && {
        title: (
          <TreeSelectNodeTitle
            title={title}
            searchValue={searchValue}
            isMuted={!item.isCurationEnabled}
          />
        ),
      }),
      ...(!isEmpty(item.children) && {
        children: renderTreeSelectHighlightsForSearch(
          item.children,
          searchValue,
        ),
      }),
    }
  })

const handleTreeSelectDropdownSearchHighlights = origin => {
  if (!isEmpty(origin?.props?.searchValue)) {
    return {
      ...origin,
      props: {
        ...origin.props,
        options: renderTreeSelectHighlightsForSearch(
          origin.props.options,
          origin.props.searchValue,
        ),
      },
    }
  }

  return origin
}

export default handleTreeSelectDropdownSearchHighlights
